import { Outlet, useNavigate } from "react-router";
import React, { useEffect } from "react";
import sizes from "../sizes.scss";
import { routePath } from "../../route-path";

/**
 * Redirect to the dashboard if on mobile devices.
 */
export default function RedirectMobileToDashboard(): JSX.Element {
    const navigate = useNavigate();

    useEffect(() => {
        const dashboardIsLegacy =
            window.localStorage.getItem("elokon-elofleet-legacyDashboard") === "true";
        if (window.innerWidth <= parseInt(sizes.maxWidthMobileScreens)) {
            navigate(dashboardIsLegacy ? routePath.oldDashboard(false) : routePath.dashboard());
        }
    }, [navigate]);

    return <Outlet />;
}
